let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dB4bX")).then(() => parcelRequire('iTco7'));